import styled from "@emotion/native"
import { ReactNode } from "react"
import { Spacing, Text } from "../../../ui-components"

type AutoPayListItemProps = {
  leftIcon?: ReactNode
  label: string
  rightElement: ReactNode
  onPress?: () => void
}

export function AutoPayListItem({ leftIcon, label, rightElement, onPress }: AutoPayListItemProps) {
  return (
    <Container onPress={onPress}>
      {leftIcon}
      <Spacing right={12} />
      <Text fontSize={16} lineHeight={26} fontFamily="IBMPlexSans-Medium">
        {label}
      </Text>
      <RightElementContainer>{rightElement}</RightElementContainer>
    </Container>
  )
}

const Container = styled.Pressable`
  width: 100%;
  min-height: 62px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.autoPay.listItemBackgroundColor};
  flex-direction: row;
  padding: 0 20px;
  align-items: center;
`

const RightElementContainer = styled.View`
  flex-grow: 1;
  align-items: flex-end;
`
